import dayjs from 'dayjs'
import { relationships } from 'modules/application-engine/services/healthsherpa/constants'
import { ApplicationInfo } from 'types/application'

export const getNameToShow = (application: ApplicationInfo) => {
  if (!application?.Persons?.length) {
    return application.EmployeeName
  }

  const employee = application.Persons.find(
    (person) => person.Relationship === relationships.EMPLOYEE
  )
  if (employee) return employee.FullName

  const spouseOrDomestic = application.Persons.find(
    (person) =>
      person.Relationship === relationships.SPOUSE ||
      person.Relationship === relationships.DOMESTIC_PARTNER
  )
  if (spouseOrDomestic) return spouseOrDomestic.FullName

  const children = application.Persons.filter(
    (person) =>
      person.Relationship === relationships.CHILD ||
      person.Relationship === relationships.CHILD_OF_DOMESTIC_PARTNER
  )
  if (children.length > 0) {
    const [olderChild] = children.sort(
      (a, b) =>
        Date.parse(a.DateOfBirth || '') - Date.parse(b.DateOfBirth || '')
    )
    return olderChild.FullName
  }

  return application.EmployeeName
}

export const transformApplicationsForCsv = (
  applications: ApplicationInfo[]
) => {
  return applications.map((app) => {
    return {
      Name: getNameToShow(app) || '',
      'Company Name': app.CompanyName || '',
      'Cart Status': app.CartCommitted ? 'Closed' : 'Open',
      'Benefit ID': app.Id,
      'Application Type': app.RenewalInformation?.isRenewal ? 'Renewal' : '',
      'Benefit Effective Date': app.BenefitEffectiveDate
        ? dayjs(app.BenefitEffectiveDate).format('MM/DD/YYYY')
        : '',
      Carrier: app.CarrierName || '',
      'Carrier Plan Change': app.CarrierPlanChange
        ? String(app.CarrierPlanChange).toLowerCase()
        : '',
      'Cart Committed': app.CarrierApplication?.WorkerSubmittedDate
        ? dayjs(app.CarrierApplication?.WorkerSubmittedDate).format(
            'MM/DD/YYYY'
          )
        : '',
      'Commission Partner': app.CommissionPartner || '',
      'SureCo Submitted': app.CarrierApplication?.HixmeSubmittedDate,
      'Member ID': app.PolicyNumber || '',
      State: app.StateProvince || '',
      Status:
        app.CarrierApplication?.Status === 'Validated'
          ? 'Verified'
          : app.CarrierApplication?.Status || '',
      'Is Test User': app.IsTestUser ? 'Yes' : 'No',
      'Is Active': app.IsActive ? 'Yes' : 'No',
      'Is Bundle Split': app.IsBundleSplit ? 'Yes' : 'No',
      'Needs Attention': app.CarrierApplication?.NeedsAttention ? 'Yes' : 'No',
      'Needs Attention Reason': JSON.stringify(app.NeedsAttentionReason) || '',
    }
  })
}
